import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { ApiResponse } from "../../../classes/api-response";
import { Constants } from "../../../utils/constants";
import { SnackService } from "../../../services/snack.service";
import { StorageService } from "../../../services/storage.service";
import { merge } from "lodash-es";
import { Storage } from "../../../model/storage";
import { Testbed } from "../../../model/testbed";
import { TestbedsService } from "../../../services/testbeds.service";

@Component({
  selector: 'aw-storage-form',
  templateUrl: './storage-form.component.html',
  styleUrls: ['./storage-form.component.scss']
})
export class StorageFormComponent implements OnInit {

  storageForm: UntypedFormGroup;
  loadingTestbeds = false;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  generalError?: ApiResponse;
  isEditing = false;
  entities = Constants.entities;
  testbeds: Testbed[] = [];
  isContextual = false;

  constructor(
    private storageService: StorageService,
    private testbedService: TestbedsService,
    private snackService: SnackService,
  ) {


    this.storageForm = new UntypedFormGroup(
      {

        totalSpace: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.min(0),
          ]
        ),
        testbed: new UntypedFormControl(
          { value: null, disabled: this.isEditing },
          [
            Validators.required
          ]
        ),
      }
    );
  }

  _storage = new Storage();

  @Input() set storage(value: Storage) {
    this._storage = merge(new Storage(), value);
    this.isEditing = !!this._storage.id;
    this.storageForm.patchValue(this._storage);
    this.storageForm.controls.totalSpace.setValidators([
      Validators.required,
      Validators.min(Math.ceil(value.usage / Constants.general.oneMegaInBytes)),
    ]);
  }

  @Input() set testbed(value: Testbed) {
    this._storage.testbed = value;
    this.isContextual = !!value;
  }

  testbedComparator(t1: Testbed, t2: Testbed): boolean {
    return t1 && t2 ? t1.id === t2.id : t1 === t2;
  }

  ngOnInit(): void {
    this.loadingTestbeds = true;

    if (!this.isEditing && !this.isContextual) {
      this.testbedService.getAllTestbeds().subscribe(testbed => {
        this.testbeds = testbed.filter(testbed => !testbed.storage);
        this.loadingTestbeds = false;
      });
    } else {
      this.testbeds = this._storage.testbed ? [this._storage.testbed] : [];
      this.storageForm.controls.testbed.disable();
      this.loadingTestbeds = false;
    }
  }

  saveStorage(): void {

    this.saving = true;

    const newStorage = merge(new Storage(), this._storage, this.storageForm.value);

    this.generalError = undefined;

    if (this._storage.id) {
      this.storageService.updateStorage(newStorage)
        .subscribe(
          () => {
            this.saving = false;
            this._storage = newStorage;
            this.snackService.success('Storage updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {

      this.storageService.createStorage(newStorage)
        .subscribe(
          () => {
            this.saving = false;
            this._storage = newStorage;
            this.snackService.success('Storage created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }

}
